import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReleaseLicensePage } from './release-license.page';

const routes: Routes = [
  {
    path: '',
    component: ReleaseLicensePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReleaseLicensePageRoutingModule {}
